export default __webpack_public_path__ + "media/music/1b754e45c7318ab5ea302398e7ac7f47.mp3";